<template>
  <div class="q-ml-sm text-brand-5 text-weight-bold titulo-input">
    {{ label }}
  </div>
  <q-select
    dense
    v-model="model"
    use-input
    hide-selected
    outlined
    fill-input
    class="select-btn"
    input-debounce="0"
    :options="options"
    option-label="label"
    option-value="value"
    emit-value
    map-options
    @filter="filterFn"
    :rules="[(val) => (val && val.length > 0) || 'Campo Obrigatório']"
  >
    <template v-slot:no-option>
      <q-item>
        <q-item-section class="text-grey"> Sem resultados </q-item-section>
      </q-item>
    </template>
  </q-select>
</template>

<script>
import { ref, watch, onMounted } from "vue";
import { useStore } from "vuex";

export default {
  props: ["label", "unidadeId"],
  setup(props, { emit }) {
    const store = useStore();
    const options = ref([]);

    let model = ref(null);

    const getData = async () => {
      options.value = [];
      try {
        let resposta = await store.dispatch("pdt/getFuncionariosParceiros", {});

        resposta.data.resultado.dados.forEach((e) => {
          options.value.push({
            label: `${e.nome} - ${e.cnpj}`,
            value: `${e.parceiroId} - ${e.cnpj} - ${e.nome}`,
            parceiroId: e.parceiroId,
            nome: e.nome,
            cnpj: e.cnpj,
          });
        });
      } catch (error) {
        console.log(error);
      }
    };

    onMounted(getData);

    watch(model, () => {
      emit("selectValue", model.value);
    });

    return {
      options,
      filterFn(val, update) {
        update(() => {
          const needle = val.toLowerCase();
          options.value = options.value.filter(
            (v) => v.label.toLowerCase().indexOf(needle) > -1
          );
        });
      },
      getData,
      model,
    };
  },
};
</script>

<style scoped>
@media (max-width: 600px) {
  .titulo-input {
    font-size: 11px !important;
    margin: 0px;
  }
  .select-btn {
    font-size: 10px !important;
  }
}
</style>
